export default __webpack_public_path__ + "images/2448ea1c41c752eecf6f33c3facb61f0.png";